import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import "./styles-v2.css";
import App from "./App";
import { bootstrapTheme } from "./modules/shared/theme";

bootstrapTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
